import React from 'react';

import TicketInfo from '../../components/ui/TicketInfo.jsx';

function CreateTickets() {
  return (
    <>
      <TicketInfo />
    </>
  );
}

export default CreateTickets;
